import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './Security.css';
import { Box, Grid } from '@mui/material';

const Security = () => {
  const { t } = useTranslation();

  return (
    <div className='security' id='security' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid container className='body'>
        <Grid container item xs={12} md={7} className='right' >
          <label>{t(`security.label`)}</label>
          <h1>{t(`security.title`)}<span>{t(`security.title2`)}</span></h1>
          <pre>{t(`security.description`)}</pre>
          <img className='image1 mobile' src={Images.tiim.security} alt='security' />
          <Box>
            <h2>{t(`security.benefits`)}</h2>
            {
              t(`security.benefitsList`).map((item, index) => (
                <Grid key={index} container flexDirection={'row'} gap={2} >
                  <img className='check' src={Images.icons.circleCheck2} alt={'check'} />
                  <h4>{item}</h4>
                </Grid>
              ))
            }
          </Box>
        </Grid>
        <Grid container item xs={12} md={5} className='left desktop' >
          <img className='image1' src={Images.tiim.security} alt='security' />
        </Grid>
      </Grid>
    </div>

  )
}

export default Security 